import Skeleton from '@mui/material/Skeleton';
import './clock-in-modal.scss';

export const ClockInSkeleton = () => {
  return (
    <div className="clockin-skeleton">
      <Skeleton
        variant="rectangular"
        width="100%"
        height={300}
        sx={{ borderRadius: 3 }}
      />

      {/* INFO SKELETON - Location */}
      <div className="clockin-skeleton__info">
        <Skeleton width="30%" height={18} />
        <Skeleton width="80%" height={18} />
      </div>

      <div className="clockin-skeleton__info">
        <Skeleton width="30%" height={18} />
        <Skeleton width="60%" height={18} />
      </div>
    </div>
  );
};
